import PropTypes from 'prop-types';
export default {
  breadcrumbs: PropTypes.shape({}).isRequired,
  browseOptions: PropTypes.shape({}),
  localities: PropTypes.shape({}).isRequired,
  nearbyLocalities: PropTypes.shape({}),
  desktopNearbyLocalities: PropTypes.shape({}),
  pow: PropTypes.shape({}),
  heading: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired
  }).isRequired,
  parentLink: PropTypes.shape({
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  advancedSearchLink: PropTypes.string.isRequired
};